import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import {
  thumbsSwiperInit,
  thumbsSwiperBtnListener,
} from "../helpers/product_swiper";
import { thumbsSwiperListener } from "../helpers/propertyListener";
import { renderRelatedPosts } from "../helpers/renderTemplate";
// import { getRelatedCaseApi } from "../helpers/shareApi(沒東西)";

const swiperData = {
  _index: 0,
};
const apiData = { ...DHHU_vars };

singleProductInit();
/**
 * 產品內頁初始化
 */
function singleProductInit() {
  swiperInit();
  // getRelatedCaseApi(apiData, renderRelatedPosts);
}

/**
 * 內頁輪播圖初始化
 */
function swiperInit() {
  const thumbsSwiper_top = thumbsSwiperInit(swiperData);

  thumbsSwiperListener(swiperData, thumbsSwiper_top);
  thumbsSwiperBtnListener(swiperData);
  swipePerView();
}

/**
 * 其他花色輪播圖
 */
function swipePerView() {
  const swiperPerView = new Swiper(".swiper__perView", {
    modules: [Navigation],
    slidesPerView: 2,
    spaceBetween: 10,
    breakpoints: {
      576: {
        // 當螢幕寬度大於等於 576
        slidesPerView: 3,
        spaceBetween: 15,
      },
      768: {
        // 當螢幕寬度大於等於 768
        slidesPerView: 4,
        spaceBetween: 20,
      },
      992: {
        // 當螢幕寬度大於等於 768
        slidesPerView: 5,
        spaceBetween: 25,
      },
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
